module.exports = __webpack_public_path__ + "media/images/country_flags/gn-33215bd229fab6729bd37e248685b189.png";